/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */

import MaasOidcProvider from '@maas-tools/auth-oidc'
import ReactDOM from 'react-dom'
import App from 'App'
import { AppProvider } from 'components/AppContext'
import PageLoading from 'containers/PageLoading'
import { router } from 'routes'
import { getConfiguration } from './common/utils/get-config'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <MaasOidcProvider
    config={getConfiguration()}
    loadingComponent={PageLoading}
    initializeSecurely={false}
  >
    <AppProvider value={{ runtimeMode: 'default' }}>
      <App router={router} shouldRenderSideBar={false} />
    </AppProvider>
  </MaasOidcProvider>,
  document.getElementById('root')
)

reportWebVitals()
